import { type FC, type PropsWithChildren } from 'react'

import { EVM, Solana, UTXO, createConfig } from '@lifi/sdk'
import { WalletManagementProvider } from '@lifi/wallet-management'
import { WalletManagementConfig } from '@lifi/wallet-management'

import { QUICKNODE_RPCS } from '@src/configs/rpc'
import { defaultCoinbaseConfig } from '@src/configs/wallet/coinbase'
import { defaultMetaMaskConfig } from '@src/configs/wallet/metaMask'
import { defaultWalletConnectConfig } from '@src/configs/wallet/walletConnect'
import { useWalletMenuModifier } from '@src/hooks/useWalletMenuModifier'
import { EVMProvider } from '@src/providers/Wallet/EVMProvider'
import { SVMProvider } from '@src/providers/Wallet/SVMProvider'
import { UTXOProvider } from '@src/providers/Wallet/UTXOProvider'

const WalletMenuProvider: FC<PropsWithChildren> = ({ children }) => {
    const config: WalletManagementConfig = {
        locale: 'en',
        metaMask: defaultMetaMaskConfig,
        coinbase: defaultCoinbaseConfig,
        walletConnect: defaultWalletConnectConfig,
    }

    // Apply custom modifications to the wallet menu
    useWalletMenuModifier()

    return <WalletManagementProvider config={config}>{children}</WalletManagementProvider>
}

export function Web3ModalProvider({ children }: React.PropsWithChildren) {
    createConfig({
        apiKey: process.env.SECRET_LIFI_API_KEY,
        apiUrl: process.env.REACT_APP_LIFI_API_URL,
        providers: [EVM(), Solana(), UTXO()],
        integrator: 'mach.exchange',
        rpcUrls: QUICKNODE_RPCS,
        preloadChains: true,
    })

    return (
        <EVMProvider>
            <UTXOProvider>
                <SVMProvider>
                    <WalletMenuProvider>{children}</WalletMenuProvider>
                </SVMProvider>
            </UTXOProvider>
        </EVMProvider>
    )
}
